import _ from 'lodash';
const initialState ={
  loginAction:{},
  showerror:false,
  errmessage:""
}
export default (state = initialState, action) => {
  switch (action.type) {
   case  'LOGIN_ACTION':
     let object = [];
     let report = [];
     if(!_.isEmpty(action.loginAction)){
      object = _.cloneDeep(action.loginAction.modulescreens);
      _.map(object, (data) =>{
        if(data.moduleUId === "AGENT_MAPPING"){
          data["path"] = '/Dashboard/AgentMapping'
          data["icon"] = 'fas fa-clone'
          data['position'] = 7
        } else if(data.moduleUId === "CALIBRATION"){
          data['path'] = '/Dashboard/Calibration'
          data['icon'] = 'fas fa-file-code'
          data['position'] = 6
        } else if(data.moduleUId === "CLIENT_MANAGEMENT"){
          data['path'] = '/Dashboard/ClientManagement'
          data['icon'] = 'fas fa-file-invoice'
          data['position'] = 5
        } else if(data.moduleUId === "COMPLIANCE"){
          data['path'] = '/Dashboard/Compliance'
          data['icon'] = 'fas fa-file-alt'
          data['position'] = 8
        } else if(data.moduleUId === "CSAT"){
          data['path'] = '/Dashboard/CSAT'
          data['icon'] = 'fas fa-file-alt'
          data['position'] = 9
          data['moduleName'] = "CSAT / QUALITY AUDIT"
        } else if(data.moduleUId === "DYNAMIC_FORM"){
          data['path'] = '/Dashboard/FormBuilder'
          data['icon'] = 'fas fa-file-alt'
          data['position'] = 4
          data['moduleName'] = "Evaluation Template"
        } else if(data.moduleUId === "FILE_UPLOAD"){
          data['path'] = '/Dashboard/FileUpload'
          data['icon'] = 'fas fa-file-upload'
          data['position'] = 10
        } else if(data.moduleUId === "INBOX"){
          data['path'] = '/Dashboard/Inbox'
          data['icon'] = 'fas fa-inbox'
          data['position'] = 1
        }  else if(data.moduleUId === "INVENTORY_MANAGEMENT"){
          data['path'] = '/Dashboard/Inventory'
          data['icon'] = 'fas fa-cubes'
          data['position'] = 2
        } else if(data.moduleUId === "USER_MANAGEMENT"){
          data['path'] = '/Dashboard/Users'
          data['icon'] = 'fas fa-user'
          data['position'] = 3
        } else if(data.moduleUId === "SAMPLING"){
          data['path'] = '/Dashboard/Sampling'
          data['icon'] = 'fas fa-file-contract'
          data['position'] = 11
        } else if(data.moduleUId === "WEB_FORM"){
          data['path'] = '/Dashboard/WebForm'
          data['icon'] = 'fas fa-file-excel'
          data['position'] = 12
          data['moduleName'] = "WEB FORM MANAGEMENT"
        } else if(data.moduleUId === "WEB_FORM_REPORT_SUBMISSION"){
          data['path'] = '/Dashboard/WebFormReportSubmission'
          data['icon'] = 'fas fa-file-excel'
          data['position'] = 13
          data['moduleName'] = "WEB FORM"
        } else if(data.moduleUId === "RE-ASSIGN"){
          data['path'] = '/Dashboard/Re-Assign'
          data['icon'] = 'fas fa-copy'
          data['position'] = 14
        } else if(data.moduleUId === "RAW_DATA_DUMP"){
          data['path'] = '/Dashboard/DataDump'
          data['icon'] = 'fas fa-copy'
          data['position'] = 15
        } else if(data.moduleUId === "SEARCH_WORK_ITEM"){
          data['path'] = '/Dashboard/SearchWI'
          data['icon'] = 'fas fa-copy'
          data['position'] = 16
        } else if(data.moduleUId === "UPLOAD_CONTACTS"){
          data['path'] = '/Dashboard/UploadContacts'
          data['icon'] = 'fas fa-copy'
          data['position'] = 17
          data['moduleName'] = "UPLOAD USER ID'S"
        } else if(data.moduleUId === "SAMPLING_DYNAMIC_CREATION"){         
            data['path'] = '/Dashboard/DynamicCreation'
            data['icon'] = 'fas fa-table'
            data['position'] = 18
            data['moduleName'] = "Sampling target"         
        }         
      })
      _.remove(object, {moduleUId:"USER_GROUP_MANAGEMENT"})
      if(action.loginAction.userName === "CCX1009" || action.loginAction.userName === "SysAdmin"){
     
       } else {
        _.remove(object, {moduleUId:"SAMPLING_DYNAMIC_CREATION"})
        _.remove(object, {moduleUId:"SAMPLING_MANUAL_ASSIGN"})
       }
      
      object = _.sortBy(object, ['position'])
      report = _.cloneDeep(action.loginAction.reports)
      _.map(report, (obj) =>{
        if(obj.id === 18){
          obj['path'] ="/Dashboard/AgentBanding"
          obj['position'] = 5
        } else if(obj.id === 26){
          obj['path'] ="/Dashboard/Agentwisescore"
          obj['position'] = 7
        } else if(obj.id === 33){
          obj['path'] ="/Dashboard/AgentNPSReport"
          obj['position'] = 6
        } else if(obj.id === 4){
          obj['path'] ="/Dashboard/AgentWiseOverallTagging"
          obj['position'] = 2
        } else if(obj.id === 9){
           obj['path'] ="/Dashboard/AgentwiseRepeatReport"
           obj['position'] = 3
        } else if(obj.id === 3){
           obj['path'] ="/Dashboard/AgentWiseUniqueTaggingReport"
           obj['position'] = 4
        } else if(obj.id === 21){
           obj['path'] ="/Dashboard/AHTWiseScore"
           obj['position'] = 1
        } else if(obj.id === 7){
            obj['path'] ="/Dashboard/CLIDRepeatReport"
            obj['position'] = 8
        } else if(obj.id === 35){
            obj['path'] ="/Dashboard/DateNPSReport"
            obj['position'] = 10
        } else if(obj.id === 13){
          obj['path'] ="/Dashboard/FirstAgentRepeatReport"
          obj['position'] = 11
        } else if(obj.id === 32){
          obj['path'] ="/Dashboard/NPSdetailed"
          obj['position'] = 15
        } else if(obj.id === 16){
          obj['path'] ="/Dashboard/MontlyAuditReport"
          obj['position'] = 14
        } else if(obj.id === 37){
            obj['path'] ="/Dashboard/NPSSummary"
            obj['position'] = 16
        } else if(obj.id === 20){
          obj['path'] ="/Dashboard/ParameterwiseAudit"
          obj['position'] = 17
        } else if(obj.id === 36){
          obj['path'] ="/Dashboard/ProductNPSReport"
          obj['position'] = 19
        } else if(obj.id === 12){
          obj['path'] ="/Dashboard/ReportProductWiseRepeatReport"
          obj['position'] = 18
        } else if(obj.id === 23){
          obj['path'] ="/Dashboard/Productwisescore"
          obj['position'] = 20
        } else if(obj.id === 19){
          obj['path'] ="/Dashboard/QAPerformanceMonth"
          obj['position'] = 22
        } else if(obj.id === 17){
            obj['path'] ="/Dashboard/QAWiseAlignment"
            obj['position'] = 21
        } else if(obj.id === 8){
          obj['path'] ="/Dashboard/QAPaudits"
          obj['position'] = 23
        } else if(obj.id === 24){
          obj['path'] ="/Dashboard/SkillSetwiseScore"
          obj['position'] = 24
        } else if(obj.id === 11){
          obj['path'] ="/Dashboard/SkillSetWiseRepeatReport"
          obj['position'] = 25
        } else if(obj.id === 2){
          obj['path'] ="/Dashboard/TaggingSpikeReport"
          obj['position'] = 30
        } else if(obj.id === 5){
          obj['path'] ="/Dashboard/taggingwiseAHT"
          obj['position'] = 31
        } else if(obj.id === 1){
          obj['path'] ="/Dashboard/TaggingWiseCallVolume"
          obj['position'] = 33
        } else if(obj.id === 6){
            obj['path'] ="/Dashboard/taggingwiseRepeat"
            obj['position'] = 32
        } else if(obj.id === 22){
          obj['path'] ="/Dashboard/TenureWiseScore"
          obj['position'] = 34
        } else if(obj.id === 25){
          obj['path'] ="/Dashboard/TlwiseScore"
          obj['position'] = 27
        } else if(obj.id === 34){
          obj['path'] ="/Dashboard/TLNPSReport"
          obj['position'] = 28
        } else if(obj.id === 10){
          obj['path'] ="/Dashboard/TLWiseRepeatReport"
          obj['position'] = 26
        } else if(obj.id === 15){
          obj['path'] ="/Dashboard/TNIReport"
          obj['position'] = 29
        } else if(obj.id === 31){
          obj['path'] ="/Dashboard/webFormReport"
          obj['position'] = 37
        } else if(obj.id === 27){
          obj['path'] ="/Dashboard/Variance"
          obj['position'] = 36
        } else if(obj.id === 28){
          obj['path'] ="/Dashboard/VarinaceDetails"
          obj['position'] = 35
        } else if(obj.id === 30){
          obj['path'] ="/Dashboard/ClientView"
          obj['position'] = 9
        } else if(obj.id === 29){
          obj['path'] ="/Dashboard/ManagementSummary"
          obj['position'] = 12
        }  else if(obj.id === 14){
          obj['path'] ="/Dashboard/ManagementView"
          obj['position'] = 13
        }          
    })  
    
    
    
    //  _.remove(report, {id: 13})
     report = _.sortBy(report, ['position'])
    }
    return Object.assign({}, state, {      
      loginAction: action.loginAction,
      showerror: action.showerror,
      isPending: action.isPending,
      session: action.session,
      menuOptions: object,
      reportOptions: report

    })
  case 'FORGOT_OTP_SUCCESS':
    return Object.assign({}, state, {
      errmessage: action.message,
      showerror: action.showerror,
      showOTP: action.showOTP,
      isPending: action.isPending
    })
  case 'FORGOT_OTP_SUCCESS_VALIDATE':
    return Object.assign({}, state, {
      errmessage: action.message,
      showerror: action.showerror,
      showReset: action.showReset
  })
  case 'RESET_PASSWORD_SUCCESS':
    return Object.assign({}, state, {
      errmessage: action.message,
      showerror: action.showerror,
      resetDone: action.resetDone
  })
  case 'LOGIN_ACTION_ERROR':
    return Object.assign({}, state, {
      errmessage: action.message,
      showerror: action.showerror,
      isPending: action.isPending,      
      resetDone: action.resetDone,
      loginAction: action.loginAction,
      session: action.session,
      isAuthenticated:action.isAuthenticated
    })
  case 'LOGIN_ACTION_PENDING':
    return Object.assign({}, state, {
      isPending: action.isPending
    })
  case "LOGIN_ACTION_MODAL_CLOSE":
    return Object.assign({}, state, {
      showerror: action.showerror,
    })
  case "RESET_ALL":
    return Object.assign({}, state, {
      showOTP: action.showOTP,
      showReset: action.showReset,
      resetDone: action.resetDone
    })
   default:
    return state
  }
 }